import { useState, useEffect, useContext } from "react";
import { addDescripcionToAulas } from "../Services/FormService";
import { fetchAulasByEstado } from "../Services/GeneracionLinkService";
import { parseArrayToReactSelect } from "../Services/UltilsService";

const useAulas = (idServicio, conDescripcion = false, grupo) => {
  const [aulas, setAulas] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!idServicio) return;

    (async () => {
      setIsFetching(true);
      setAulas(await getAulas(idServicio));
      setIsFetching(false);
    })();
  }, [idServicio]);

  const getAulas = async () => {
    if (grupo == 1 || grupo == 11 || grupo == 12) {
      const AulaEnEsperaCar = parseArrayToReactSelect(
        [{ id: 19, alias: "AULA EN ESPERA (C)" }],
        "id",
        "alias"
      );
      return AulaEnEsperaCar;
    }

    if (grupo == 5) {
      const AulaEnEsperaPos = parseArrayToReactSelect(
        [{ id: 18, alias: "AULA EN ESPERA (P)" }],
        "id",
        "alias"
      );
      return AulaEnEsperaPos;
    }

    const porIniciar = await fetchAulasByEstado(idServicio, "por_iniciar");
    const enCurso = await fetchAulasByEstado(idServicio, "en_curso");
    const porIniciarFilter = [];

    porIniciar.forEach(item => {
      if (item && item.vacanteMax == false) {
        porIniciarFilter.push(item);
      }
    });

    if (!conDescripcion) {
      return parseArrayToReactSelect(
        porIniciar.concat(enCurso),
        "id",
        "alias"
      );
    }

    return addDescripcionToAulas(porIniciar.concat(enCurso));
  };

  return { aulas, isFetching };
};

export default useAulas;
